import api from '../utils/api';

const BASE = '/api/pinned-scenarios';

/**
 * Get a creator's pinned scenarios (scenario populated on each pin).
 * @route GET /api/pinned-scenarios/:creatorId
 * @param {string} creatorId
 * @returns {Promise<Object[]>}
 */
export const getPinnedScenarios = (creatorId) =>
    api.get(`${BASE}/${creatorId}`).then((r) => r.data);

/**
 * Pin one of the logged-in user's own scenarios (max 3).
 * @route POST /api/pinned-scenarios/:scenarioId
 * @param {string} scenarioId
 * @returns {Promise<Object>}
 */
export const pinScenario = (scenarioId) =>
    api.post(`${BASE}/${scenarioId}`).then((r) => r.data);

/**
 * Unpin a scenario.
 * @route DELETE /api/pinned-scenarios/:scenarioId
 * @param {string} scenarioId
 * @returns {Promise<Object>}
 */
export const unpinScenario = (scenarioId) =>
    api.delete(`${BASE}/${scenarioId}`).then((r) => r.data);

/**
 * Check whether the logged-in user has pinned a scenario.
 * @route GET /api/pinned-scenarios/check/:scenarioId
 * @param {string} scenarioId
 * @returns {Promise<{isPinned: boolean}>}
 */
export const checkPinnedScenario = (scenarioId) =>
    api.get(`${BASE}/check/${scenarioId}`).then((r) => r.data);
